/**
 * Creates a new key/value pair in local storage.
 * @param key Key of item to be storage from local storage.
 * @param value Value of item to be stored in local storage.
 */
export const setLocalItem = (key: string, value: string): void => {
  if (typeof window !== 'undefined') {
    localStorage.setItem(key, value);
  }
};

/**
 * Retrieves an item from local storage by its key.
 * @param key Key of item to be retrieved from local storage as string.
 * @returns promise with string value for given key if found, or null if not.
 * @async
 */
export const getLocalItem = async (key: string): Promise<string | null> => {
  if (typeof window !== 'undefined') {
    const value = localStorage.getItem(key);
    return value;
  }
  return null;
};

/**
 * Removes a single key/value pair from local storage.
 * @param key Key of item to be removed from local storage.
 */
export const removeLocalItem = (key: string): void => {
  if (typeof window !== 'undefined') {
    localStorage.removeItem(key);
  }
};

/**
 * Removes all key/value pairs from local storage, if present.
 */
export const clearLocal = (): void => {
  if (typeof window !== 'undefined') {
    localStorage.clear();
  }
};

/**
 * Creates a new key/value pair in session storage.
 * @param key Key of item to be storage from session storage.
 * @param value Value of item to be stored in session storage.
 */
export const setSessionItem = (key: string, value: string): void => {
  if (typeof window !== 'undefined') {
    sessionStorage.setItem(key, value);
  }
};

/**
 * Retrieves an item from session storage by its key.
 * @param key Key of item to be retrieved from session storage as string.
 * @returns promise with string value for given key if found, or null if not.
 * @async
 */
export const getSessionItem = async (key: string): Promise<string | null> => {
  if (typeof window !== 'undefined') {
    const value = sessionStorage.getItem(key);
    return value;
  }
  return null;
};

/**
 * Removes a single key/value pair from session storage.
 * @param key Key of item to be removed from session storage.
 */
export const removeSessionItem = (key: string): void => {
  if (typeof window !== 'undefined') {
    sessionStorage.removeItem(key);
  }
};

/**
 * Removes all key/value pairs from session storage, if present.
 */
export const clearSession = (): void => {
  if (typeof window !== 'undefined') {
    sessionStorage.clear();
  }
};
